import { render, staticRenderFns } from "./EditPersonAvailabilityDialog.vue?vue&type=template&id=0489ba62&scoped=true&"
import script from "./EditPersonAvailabilityDialog.vue?vue&type=script&lang=js&"
export * from "./EditPersonAvailabilityDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0489ba62",
  null
  
)

export default component.exports